<template>
    <section class="internal-page">
        <internal-page-header
            eyebrow="Área do credor"
            title="Habilitações e divergências"
            description="Acompanhe suas solicitações e consulte os documentos enviados."
        >
            <v-btn
                v-if="user"
                to="/habilitacoes-divergencias/novo"
                color="secondary"
                class="pbb-btn"
                >Nova solicitação <v-icon right size="18">mdi-arrow-right</v-icon></v-btn
            >
        </internal-page-header>
        <v-container class="pa-0 mx-auto">
            <creditor-access-notice v-if="!user" />
            <page-state
                v-else-if="loading || !data.length"
                :loading="loading"
                title="Nenhuma solicitação encontrada"
                description="Suas habilitações e divergências aparecerão aqui após o envio."
            />

            <!-- <v-row justify="center">
                <v-col cols="10">
                    <div
                        v-html="!user ? dataset.contentUserAnonymous : dataset.contentUserLogged"
                    ></div>
                </v-col>
            </v-row> -->

            <v-row justify="center">
                <v-col cols="10" lg="10" v-if="user">
                    <!-- <v-row>
                        <v-col>
                            <p>
                                Para enviar uma habilitação/divergência,
                                <a href="#" @click.prevent="viewCreateEvent"
                                    ><strong>clique aqui</strong></a
                                >
                            </p>
                        </v-col>
                    </v-row> -->

                    <template v-if="data.length">
                        <v-row>
                            <v-col>
                                <span class="page-subtitle">Habilitações/Divergências</span>
                            </v-col>
                        </v-row>

                        <!-- <v-row >
                          <v-col>
                              <p>
                                  Nenhuma solicitação encontrada.
                              </p>
                          </v-col>
                      </v-row> -->

                        <div v-for="(item, i) in data" :key="i">
                            <v-row>
                                <v-col>
                                    <strong>{{ getTypeName(item) }} #{{ i + 1 }}</strong>
                                    <br />
                                    <strong>Devedora: </strong> <span>{{ item.client.name }}</span>
                                    <br />
                                    <strong>Solicitado em</strong>
                                    <span>
                                        {{
                                            $moment(item.created_at).format('DD/MM/YYYY HH:mm:ss')
                                        }}</span
                                    >
                                </v-col>
                                <v-col>
                                    <div align="right" class="mr-4">
                                        <v-tooltip
                                            left
                                            max-width="420"
                                            :disabled="!item.analysis_concluded"
                                        >
                                            <template #activator="{ on, attrs }">
                                                <v-chip
                                                    v-bind="attrs"
                                                    :color="
                                                        item.analysis_concluded
                                                            ? 'primary'
                                                            : 'warning'
                                                    "
                                                    label
                                                    :to="
                                                        item.analysis_concluded
                                                            ? caseRoute(item)
                                                            : undefined
                                                    "
                                                    v-on="on"
                                                    >{{ analysisLabel(item) }}</v-chip
                                                >
                                            </template>
                                            <span
                                                >O resultado está na relação de credores:
                                                <strong>{{ creditorListPath(item) }}</strong></span
                                            >
                                        </v-tooltip>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row
                                v-if="item.status !== 0 && (item.small_reason || item.report_url)"
                            >
                                <v-col>
                                    <div class="event-analysis">
                                        <strong>Resultado da análise</strong>
                                        <div
                                            v-if="item.small_reason"
                                            class="event-analysis__reason"
                                            v-html="item.small_reason"
                                        ></div>
                                        <a
                                            v-if="item.report_url"
                                            :href="item.report_url"
                                            target="_blank"
                                            rel="noopener"
                                            class="event-analysis__report"
                                            ><v-icon small color="primary">mdi-file-pdf-box</v-icon>
                                            Relatório de análise do crédito (PDF)</a
                                        >
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-expansion-panels>
                                        <v-expansion-panel
                                            v-for="(eventItem, eventIndex) in item.items"
                                            :key="eventIndex"
                                        >
                                            <v-expansion-panel-header>
                                                <div>
                                                    <strong>Origem:</strong>
                                                    <span>
                                                        {{
                                                            truncateText(
                                                                eventItem.origin || 'N/A',
                                                                10
                                                            )
                                                        }}
                                                    </span>
                                                    /
                                                    <strong>Valor:</strong>
                                                    <span v-if="eventItem.amount">
                                                        {{
                                                            eventItem.currency
                                                                | enum(
                                                                    dataset.currencyTypes,
                                                                    'id',
                                                                    'currencyFormat'
                                                                )
                                                        }}
                                                        {{ eventItem.amount | currency }}
                                                    </span>
                                                    <span v-else>N/A</span>
                                                </div>
                                            </v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                                <v-row>
                                                    <v-col>
                                                        <p>
                                                            <span class="section-info-title"
                                                                >Devedora</span
                                                            >
                                                            <br />
                                                            <span
                                                                class="section-info-value text-uppercase"
                                                            >
                                                                {{ item.client.name }}
                                                            </span>
                                                        </p>
                                                        <p>
                                                            <span class="section-info-title"
                                                                >Origem</span
                                                            >
                                                            <br />
                                                            <span
                                                                class="section-info-value text-uppercase"
                                                            >
                                                                {{ eventItem.origin }}</span
                                                            >
                                                        </p>
                                                        <p>
                                                            <span class="section-info-title"
                                                                >Classe</span
                                                            >
                                                            <br />
                                                            <span
                                                                class="section-info-value text-uppercase"
                                                            >
                                                                {{ getClassName(item, eventItem) }}
                                                            </span>
                                                        </p>
                                                        <p>
                                                            <span class="section-info-title"
                                                                >Moeda</span
                                                            >
                                                            <br />
                                                            <span
                                                                class="section-info-value text-uppercase"
                                                            >
                                                                {{
                                                                    eventItem.currency
                                                                        | enum(
                                                                            dataset.currencyTypes,
                                                                            'id',
                                                                            'name'
                                                                        )
                                                                }}
                                                            </span>
                                                        </p>
                                                        <p>
                                                            <span class="section-info-title"
                                                                >Valor</span
                                                            >
                                                            <br />
                                                            <span
                                                                class="section-info-value text-uppercase"
                                                                >{{
                                                                    eventItem.currency
                                                                        | enum(
                                                                            dataset.currencyTypes,
                                                                            'id',
                                                                            'currencyFormat'
                                                                        )
                                                                }}
                                                                {{
                                                                    eventItem.amount | currency
                                                                }}</span
                                                            >
                                                        </p>
                                                        <p v-if="item.status === 3">
                                                            <span class="section-info-title"
                                                                >Valor reconhecido</span
                                                            >
                                                            <br />
                                                            <span
                                                                class="section-info-value text-uppercase"
                                                                >{{
                                                                    eventItem.currency
                                                                        | enum(
                                                                            dataset.currencyTypes,
                                                                            'id',
                                                                            'currencyFormat'
                                                                        )
                                                                }}
                                                                {{
                                                                    eventItem.partial_amount
                                                                        | currency
                                                                }}</span
                                                            >
                                                        </p>
                                                        <p>
                                                            <span class="section-info-title"
                                                                >Observações</span
                                                            >
                                                            <br />
                                                            <span
                                                                class="section-info-value text-uppercase"
                                                            >
                                                                {{ eventItem.observation }}</span
                                                            >
                                                        </p>
                                                        <p>
                                                            <span class="section-info-title"
                                                                >Documentos</span
                                                            >
                                                            <br />
                                                            <span class="section-info-value"
                                                                >{{
                                                                    eventItem.docs.length
                                                                }}
                                                                arquivo(s)</span
                                                            >
                                                        </p>
                                                        <v-row>
                                                            <v-col
                                                                v-for="(
                                                                    itemDoc, docIndex
                                                                ) in eventItem.docs"
                                                                :key="docIndex"
                                                            >
                                                                <v-img
                                                                    @click="
                                                                        openDoc(
                                                                            itemDoc.doc.file_url
                                                                        )
                                                                    "
                                                                    class="rounded-xl"
                                                                    lazy-src="https://picsum.photos/id/11/10/6"
                                                                    :height="100"
                                                                    :width="100"
                                                                    :src="itemDoc.doc.file_url"
                                                                ></v-img>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                </v-row>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-divider></v-divider>
                                </v-col>
                            </v-row>
                        </div>
                    </template>

                    <v-dialog v-model="dialogViewDoc" max-width="60%" @keydown.esc="cancel">
                        <v-card>
                            <v-img :src="selectedDoc" alt="" contain />
                        </v-card>
                    </v-dialog>
                </v-col>
            </v-row>
        </v-container>
    </section>
</template>

<script>
import 'moment/locale/pt-br';

import currencyTypes from '@/common/currency-types.data';
import { getCreditorTypes } from '@/common/creditor-types.data';
import { getCaseType } from '@/common/case-types.data';

import axios from 'axios';

export default {
    data: () => ({
        user: null,
        data: [],
        loading: false,
        dataset: {
            contentUserAnonymous: '',
            contentUserLogged: '',
            currencyTypes: currencyTypes
        },
        selectedDoc: null,
        dialogViewDoc: false
    }),

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    mounted: function () {},

    created() {
        this.loadText();

        if (this.$root.user) {
            this.loadUserInfo();
            this.load();
        }
    },

    methods: {
        truncateText(text, maxLength) {
            return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
        },

        openDoc(doc) {
            this.selectedDoc = doc;
            this.dialogViewDoc = true;
        },

        async loadText() {
            try {
                const result = await axios.get(`/api/dynamic-infos/keys`, {
                    params: { keys: 'user-event-anonymous,user-event-logged' }
                });

                if (!result.data.content) return;

                let contentUserAnonymous = result.data.content.find(
                    (x) => x.key === 'user-event-anonymous'
                );

                let contentUserLogged = result.data.content.find(
                    (x) => x.key === 'user-event-logged'
                );

                this.dataset.contentUserAnonymous = contentUserAnonymous.value || '';
                this.dataset.contentUserLogged = contentUserLogged.value || '';
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            }
        },

        async loadUserInfo() {
            this.loading = true;

            try {
                const result = await axios.get('/api/users/info');

                this.user = result.data.content;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 5000
                });
            } finally {
                this.loading = false;
            }
        },

        async load() {
            this.loading = true;

            try {
                const result = await axios.get('/api/user-events/request');
                console.log(result);

                this.data = result.data.content;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 5000
                });
            } finally {
                this.loading = false;
            }
        },

        // Por enquanto a análise é feita fora da plataforma: o credor vê só se o pedido foi
        // submetido ou se a análise do caso foi concluída (resultado na relação de credores).
        analysisLabel(item) {
            return item.analysis_concluded
                ? 'Análise concluída'
                : 'Submetido para apreciação da AJ';
        },

        creditorListPath(item) {
            const name = (item.client && item.client.name) || 'Caso';
            return `Casos › ${name} › Documentos › Relação de Credores`;
        },

        caseRoute(item) {
            if (!item.client) return undefined;
            return `${getCaseType(item.client.type).route}/${item.client.id}`;
        },

        getClassName(item, eventItem) {
            const types = getCreditorTypes(item.client && item.client.type);
            const found = types.find((type) => type.id === eventItem.type);
            return found ? found.name : 'N/A';
        },

        getTypeName(item) {
            return item.type == 2 ? 'Divergência' : 'Habilitação';
        },

        viewCreateEvent() {
            this.$router.push(`habilitacoes-divergencias/novo`);
        }
    }
};
</script>

<style lang="scss">
.event-analysis {
    padding: 16px 20px;
    border-left: 3px solid var(--pbb-copper, #986137);
    border-radius: 4px;
    background: #fbfaf8;
}
.event-analysis__reason {
    margin-top: 6px;
}
.event-analysis__reason p:last-child {
    margin-bottom: 0;
}
.event-analysis__report {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-top: 10px;
    font-weight: 600;
}
.title-page {
    color: var(--v-primary-base);
    font-family: 'Manrope', sans-serif;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    font-family: 'Manrope', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    font-family: 'Manrope', sans-serif;
    font-size: 14px;
    font-style: normal;
}
</style>
